import { persistStore } from './persistStorage';

export const cartStore = persistStore('cart-store', []);
